








































import Vue from 'vue';
import {
  BCard,
  BCardBody,
  BCardFooter,
  BMedia,
  BImg,
  BNav,
  BNavItem,
} from 'bootstrap-vue';
import { Section } from '@/common/types';

export default Vue.extend({
  computed: {
    section(): Section {
      return this.$store.getters.section;
    },
    type(): string {
      return this.$store.state.pageQuery.type;
    },
  },
  metaInfo() {
    const $this = this as any;
    return {
      title: ($this.section && $this.section.name) || $this.type,
    };
  },
  components: { BCard, BCardBody, BCardFooter, BMedia, BImg, BNav, BNavItem },
});
